import { stripHtml } from "string-strip-html";
import { buildFAQPageSchema } from '../types/FAQPage'

const FAQ_CONTENT_TYPES = [
    "CommonQuestionsBlock",
    "TransitionInfoAndCommonQuestionsBlock"
]

/**
 * Generates schema for FAQ pages
 * @param {Object} data - Page data object
 */
export default function FAQPageSchema(data) {
    if (!data) {
        return null
    }
    if (!Array.isArray(data.MainContentArea)) {
        return null
    }

    // Extract FAQ blocks from page content.
    const blocks = data.MainContentArea.filter(block => {
        return Array.isArray(block.ContentType) && block.ContentType.find(x => FAQ_CONTENT_TYPES.includes(x))
    });

    if (!blocks.length) {
        return null
    }

    // Build options object for FAQPage schema
    const options = {
        faqs: []
    }
    for (let block of blocks) {
        if (!Array.isArray(block.FrequentlyAskedQuestions))
            continue;
        for (let faq of block.FrequentlyAskedQuestions) {
            options.faqs.push({
                q: faq.Question,
                a: stripHtml(faq.Answer || "")?.result
            })
        }
    }

    return buildFAQPageSchema(options)
}